import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

const BEFORE_TURBO_CONTENT_LOAD_EVENT = "turbo:beforeTurboContentLoad";

export default class extends Controller {
  connect() {
    this.element.addEventListener("click", this.onClick);
  }

  disconnect() {
    this.element.removeEventListener("click", this.onClick);
  }

  onClick = (event) => {
    const target = event.target.closest("a");

    if (!target || target.dataset.turbo === "false" || event.defaultPrevented || target.href.length == 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const url = new URL(target.href);

    // Don't hijack anchor links or empty hrefs
    if (!url || url.hash || !url.href) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (!this.allowedRequest(target, url.href, event)) return;
    Turbo.visit(url.href);
  };

  allowedRequest(target, url, originalEvent) {
    const event = new CustomEvent(BEFORE_TURBO_CONTENT_LOAD_EVENT, {
      bubbles: true,
      cancelable: true,
      detail: {url, originalEvent},
    });

    target.dispatchEvent(event);
    return !event.defaultPrevented;
  }

  sendTurboStreamRequest({ url, method = 'GET', headers = {} }, callback) {
    const fetchOptions = {
      method,
      headers: {
        Accept: 'text/vnd.turbo-stream.html, text/html, application/xhtml+xml',
        ...headers
      }
    };

    fetch(url, fetchOptions)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.text();
      })
      .then(html => {
        Turbo.renderStreamMessage(html);
        if (typeof callback === 'function') callback();
      })
      .catch(error => console.error('Turbo stream fetch error:', error));
  }
}
